import { render, staticRenderFns } from "./matrixdropdown.vue?vue&type=template&id=0b4da6d8&"
import script from "./matrixdropdown.vue?vue&type=script&lang=ts&"
export * from "./matrixdropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4da6d8')) {
      api.createRecord('0b4da6d8', component.options)
    } else {
      api.reload('0b4da6d8', component.options)
    }
    module.hot.accept("./matrixdropdown.vue?vue&type=template&id=0b4da6d8&", function () {
      api.rerender('0b4da6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrixdropdown.vue"
export default component.exports